// frontend/src/api/vehicles.js
import { apiClient } from './index';

const vehiclesApi = {
  // --- PUBLIC & USER-FACING ENDPOINTS ---

  createListing: async (vehicleData) => {
    return await apiClient.post('/vehicles/', vehicleData);
  },

  getAllVehicles: async (filters = {}) => {
    const params = new URLSearchParams(Object.entries(filters).filter(([_, v]) => v != null));
    return await apiClient.get(`/vehicles/?${params.toString()}`);
  },

  getVehicleById: async (vehicleId) => {
    return await apiClient.get(`/vehicles/${vehicleId}`);
  },

  // --- NEW: RELATED & SELLER ITEMS ---
  getRelatedVehicles: async (vehicleId) => {
    return await apiClient.get(`/vehicles/${vehicleId}/related`);
  },

  getSellerVehicles: async (vehicleId) => {
    return await apiClient.get(`/vehicles/${vehicleId}/seller-items`);
  },

  getUserListings: async () => {
    return await apiClient.get('/vehicles/user/me');
  },

  // --- NEW: GET LISTING COUNT (For Spam Stopper Check) ---
  getUserListingCount: async () => {
      // We can reuse getUserListings and count the array, 
      // but a dedicated lightweight endpoint or just counting the array is fine.
      // For efficiency, we'll just count the array from getUserListings for now.
      const listings = await apiClient.get('/vehicles/user/me');
      return listings.length;
  },

  updateListing: async (vehicleId, updateData) => {
    return await apiClient.put(`/vehicles/${vehicleId}`, updateData);
  },

  deleteListing: async (vehicleId) => {
    return await apiClient.delete(`/vehicles/${vehicleId}`);
  },

  // --- MY GARAGE ENDPOINTS ---

  addToGarage: async (vehicleData) => {
    return await apiClient.post('/vehicles/garage', vehicleData);
  },

  getGarage: async () => {
    return await apiClient.get('/vehicles/garage');
  },

  removeFromGarage: async (vehicleId) => {
    return await apiClient.delete(`/vehicles/garage/${vehicleId}`);
  },

  // --- ADMIN ENDPOINTS ---

  getAllListingsAdmin: async () => {
    return await apiClient.get('/vehicles/admin/all');
  },

  updateListingStatusAdmin: async (listingId, status, rejectionReason = null) => {
    return await apiClient.put(`/vehicles/admin/${listingId}/status`, { 
      status, 
      rejection_reason: rejectionReason 
    });
  },

  deleteListingAdmin: async (listingId) => {
    return await apiClient.delete(`/vehicles/admin/${listingId}`);
  }
};

export { vehiclesApi };